export const CloseFileIcon = (props) => {
    return (
        <svg  width={props.width || 14} height={props.height || 15} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_21313_9461)">
        <path d="M11.7185 12.3252L1.55556 1.43628" stroke="#5B5B5B" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round"/>
        <path d="M12.4444 1.43628L1.55556 12.3252" stroke="#5B5B5B" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_21313_9461">
        <rect width="14" height="14" fill="white" transform="translate(0 0.269531)"/>
        </clipPath>
        </defs>
        </svg>        
    );
  };
  